import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@ferris/react';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { ButtonType } from '@ferris/react/components/button/Button';
import TranslationUtil from '../../utils/TranslationUtil';
import { createInteractionEvent } from '../../utils/EventProviders/EgClickstreamUtil';

export const LoginButton = (props) => {
    const {
        authUrl,
        loginText,
        isFrboFlow,
        display,
        classes
    } = props;

    if (!display) {
        return null;
    }
    const { trigger } = useContext(TrackingContext);
    const onClick = () => {
        trigger('interaction', createInteractionEvent(isFrboFlow ? 'vr_login.selected' : 'pco_login.selected', '', '', 'NavBar', isFrboFlow ? '2.4.0' : '2.4.1'));
    };
    return (
        <a
            href={authUrl}
            onClick={onClick}
            className={classes}
        >
            <Button
                type={ButtonType.UTILITY}
            >
                {loginText}
            </Button>
        </a>
    );
};

LoginButton.propTypes = {
    authUrl: PropTypes.string.isRequired,
    loginText: PropTypes.string.isRequired,
    isFrboFlow: PropTypes.bool.isRequired,
    display: PropTypes.bool.isRequired,
    classes: PropTypes.string // Optional additional classes for the button
};

LoginButton.defaultProps = {
    // Default to an empty string for classes if not provided
    classes: ''
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app } = state;
    const {
        features, locale, rootPath
    } = app;
    const getClHostName = () => {
        let host = 'apps.expediapartnercentral.com';
        if (typeof window === 'object') {
            host = window?.location?.hostname || host;
        }

        if (host.includes('local.')) {
            host = 'apps.expediapartnercentral.com.integration.sb.karmalab.net';
        }

        return host;
    };

    const getAuthUrl = () => {
        if (features.isFrboFlow) {
            const loginInterstitialLink = `/${locale.display}/${rootPath}/login-interstitial`;
            return `/login?enable_login=true&referrer_page_location=homepage&redirectTo=${loginInterstitialLink}`;
        }

        return `https://${getClHostName()}/onboarding/addProperty`;
    };

    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const loginText = translations.getTranslation('lyp.header.login.text');

    const authUrl = getAuthUrl();
    return {
        isFrboFlow: features.isFrboFlow,
        authUrl,
        loginText
    };
};

const ConnectedLoginButton = connect(mapStateToProps)(LoginButton);
export default ConnectedLoginButton;
